import React, { PureComponent } from "react";
// import { emptyFn } from '../utils';
import defaultSelectionRenderer from "./defaultSelectionRenderer";
import classNames from "classnames";
import styles from "./Header.scss";
import { string, shape, func, arrayOf, oneOf, oneOfType, objectOf } from "prop-types";

export default class Header extends PureComponent {


    static propTypes = {
        layout: string,
        locale: shape({
            blank: string,
            headerFormat: string,
            todayLabel: shape({
                long: string,
                short: string
            }),
            weekdays: arrayOf(string),
            weekStartsOn: oneOf([0, 1, 2, 3, 4, 5, 6])
        }),
        selected: objectOf(string),
        theme: shape({
            floatingNav: shape({
                background: string,
                chevron: string,
                color: string
            }),
            headerColor: string,
            selectionColor: oneOfType([string, func]),
            textColor: shape({
                active: string,
                default: string
            }),
            todayColor: string,
            weekdayColor: string
        }),
        renderSelection: func
        // onYearClick: func
    };

    static defaultProps = {
        // onYearClick: emptyFn,
        renderSelection: defaultSelectionRenderer
    };

    render() {
        let {
            layout,
            locale: { blank },
            selected,
            renderSelection,
            theme
        } = this.props;
        return (
            <div
                className={classNames(styles.root, {
                    [styles.landscape]: layout === "landscape"
                })}
                style={{
                    backgroundColor: theme.headerColor,
                    color: theme.textColor.active
                }}
            >
                {
                    selected && renderSelection(selected, this.props) ||
                    <div className={classNames(styles.wrapper, styles.blank)}>{blank}</div>
                }
            </div>
        );
    }
}
